module.exports = __webpack_public_path__ + "assets/ic_like_on.086815e4.svg";